import React from 'react';
import { TagContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Tag = function Tag(props) {
  return ___EmotionJSX(TagContainer, props);
};

Tag.displayName = 'Tag';
Tag.defaultProps = {
  size: 'default',
  type: 'default',
  circle: false,
  radius: '2rem'
};
export { Tag };

if (typeof Tag !== 'undefined' && Tag && Tag === Object(Tag) && Object.isExtensible(Tag) && !Object.prototype.hasOwnProperty.call(Tag, '__filemeta')) {
  Object.defineProperty(Tag, '__filemeta', {
    configurable: true,
    value: {
      name: "Tag",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tag/index.js"
    }
  });
}